import GroupDiscount from './GroupDiscount';
import GroupDiscountPricing from './GroupDiscountPricing';

import { addFilter } from '@wordpress/hooks';
import { useSelect, dispatch } from '@wordpress/data';

// Category Group Discount [default]
addFilter(
    'wp_travel_after_pricings_category_fields',
    'wp_travel',
    (content, ...params ) => {
        // content.splice(0, 1)
        return [...content,  <GroupDiscount key="group-discount" priceIndex={params[0]} catIndex={params[1]} />]
    },
    15
);


addFilter(
    'wptravel_pricings_after_max_pax',
    'wp_travel',
    (content, ...params ) => {
        // content.splice(0, 1)
        return [...content, <GroupDiscountPricing key="group-discount" allData={params[0]} price={params[1]} priceIndex={params[2]} /> ]
    },
    15
);